module.exports = __webpack_public_path__ + "static/media/icon_105.e2e02465.svg";